import { Helmet } from 'react-helmet-async';
 
const SEO = ({
  title = '',
  description = '',
  canonical,
//   ogImage = '',
}) => {
//   const siteUrl = '';
//   const fullCanonical = canonical ? `${siteUrl}${canonical}` : `${siteUrl}/about-us/`;
   const fullCanonical = canonical;
//   const fullOgImage = ogImage.startsWith('http') ? ogImage : `${siteUrl}${ogImage}`;
const fullOgImage = "/favicon.ico"
const keywords = "MSME Loans Delhi NCR, Business Loans, Unsecured Loans, CGTMSE Loans, Working Capital Finance, Equipment Finance"
const ogType = 'website'
const twitterCard = 'summary_large_image'
 
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={fullCanonical} />
 
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={fullCanonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullOgImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Dequitec" />
      <meta property="og:locale" content="en_IN" />
 
      {/* Twitter */}
      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:site" content="@dequitec" />
      <meta name="twitter:creator" content="@dequitec" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullOgImage} />
 
      {/* Additional Tags */}
      <meta name="robots" content="index, follow, max-image-preview:large" />
      <meta name="author" content="Dequitec" />
    </Helmet>
  );
};
 
export default SEO;